<script setup lang="ts">
    /*
     * The pencil is wrapped in a native button rather than a `b-button`: the cell has to look like
     * nothing but the icon, and Bulma's button styling would have to be undone piece by piece to
     * get there. Being a button is still what makes the whole cell respond to the pointer, and what
     * makes editing reachable from the keyboard, which a bare icon is not.
     *
     * The template must stay a single root element with no comment above it. A comment there makes
     * the component a multi-root fragment, which AG Grid's cell renderer cannot mount: the cell
     * silently renders empty.
     *
     * The button is styled from `CodeGrid.vue` instead of a scoped block here. AG Grid instantiates
     * cell renderers outside the normal component tree, so they never receive the `data-v-`
     * attribute that scoped styles match on and the rules would be dropped.
     */
    import type { CodeEditCellRendererParams } from './CodeGrid.helper';

    const props = defineProps<{
        params: CodeEditCellRendererParams;
    }>();

    function onClick() {
        if (props.params.data)
            props.params.onEdit(props.params.data);
    }
</script>

<template>
    <button
        class="edit-cell-button"
        type="button"
        title="Edit item"
        @click="onClick">
        <b-icon
            icon="pencil"
            size="is-small" />
    </button>
</template>
